/* Boring People · Bodrum 2026 — mikro-site tipleri.
   Giriş yok, kişiye özel veri yok. Tüm metinler iki dilli. */

export type Lang = "tr" | "en";
export const LANGS: Lang[] = ["tr", "en"];

/** İki dilli metin. Boş kalan dil için diğerine düşülür. */
export interface I18n {
  tr: string;
  en: string;
}

export type SessionKind =
  | "plenary"
  | "tables"
  | "workshop"
  | "break"
  | "show"
  | "optional";

export const SESSION_KINDS: SessionKind[] = [
  "plenary",
  "tables",
  "workshop",
  "break",
  "show",
  "optional",
];

export interface ProgramSession {
  id: string;
  start: string;
  end: string;
  title: I18n;
  sub: I18n;
  kind: SessionKind;
  loc: I18n;
  /** Sahne alan kişi(ler) — program satırında adı görünür */
  speakerIds: string[];
}

export interface Workshop {
  id: string;
  name: I18n;
  partner: string;
  tag: I18n;
  time: string;
  loc: I18n;
  /** kart üzerinde görünen kısa açıklama */
  desc: I18n;
  /** accordion açılınca görünen uzun açıklama */
  detail: I18n;
}

export interface Speaker {
  id: string;
  name: string;
  role: I18n;
  time: string;
  bio: I18n;
  quote: I18n;
  /** /fotograflar altındaki dosya adı; boşsa baş harfler gösterilir */
  photo: string;
}

export interface DressCode {
  title: I18n;
  text: I18n;
  /** /gorseller altındaki dosya adı */
  image: string;
  imageAlt: I18n;
}

export interface EveningBlock {
  id: string;
  time: string;
  title: I18n;
  text: I18n;
}

export interface Evening {
  intro: I18n;
  blocks: EveningBlock[];
}

export interface EventMeta {
  name: string;
  tagline: I18n;
  dateLabel: I18n;
  venue: I18n;
  /** program sekmesinin altındaki pratik bilgiler */
  practical: { k: I18n; v: I18n }[];
}

/** Sitenin tüm içeriği — tek istekte gelir. */
export interface SiteContent {
  event: EventMeta;
  sessions: ProgramSession[];
  workshops: Workshop[];
  speakers: Speaker[];
  dressCode: DressCode;
  evening: Evening;
  /** içerik en son ne zaman güncellendi (önbellek kırma) */
  updatedAt: number;
}

export interface ApiError {
  error: string;
  message: string;
}

export const emptyI18n = (): I18n => ({ tr: "", en: "" });

/** Seçili dildeki metin; o dil boşsa diğerine düşer. */
export const t = (value: I18n | undefined, lang: Lang): string => {
  if (!value) return "";
  const primary = value[lang];
  if (primary && primary.trim()) return primary;
  const fallback = lang === "tr" ? value.en : value.tr;
  return fallback ?? "";
};
